<template>
    <div id="app">
        <ejs-schedule
            height='90%'
            :selectedDate='selectedDate'
            :maxDate='maxDate'
            :minDate='minDate'
            :locale='locale'
            :firstDayOfWeek='firstDayOfWeek'
            :dateFormat='dateFormat'
            :timeScale="timeScale"
            :timeFormat="timeFormat"
            :eventSettings="eventSettings"
            :eventRendered="onEventRendered"
            :editorTemplate="editorTemplate"
            :timezone="timezone"
            :created="onCreate"
            :actionBegin="onActionBegin"
            :actionComplete="onActionComplete"
            :actionFailure='onActionFailure'
            :dataBound="onDataBound"
            :navigating="onNavigating"
            :popupOpen="onPopupOpen"
            :quickInfoTemplates="quickInfoTemplates"
            :workHours="workHours"
            :startHour="startHour"
            :endHour="endHour"
            :dragStop="onDragStop">
            <e-views>
                <e-view option="Week"></e-view>
                <e-view option="Month"></e-view>
            </e-views>
        </ejs-schedule>
        <v-snackbar
            v-model="snackbar"
            :timeout="timeout"
        >
            {{ text }}
        </v-snackbar>
    </div>
</template>

<script>
//import the loadCldr from ej2-base
import {L10n, loadCldr, setCulture} from '@syncfusion/ej2-base';

loadCldr(
    require('cldr-data/supplemental/numberingSystems.json'),
    require('cldr-data/main/es-CL/ca-gregorian.json'),
    require('cldr-data/main/es-CL/numbers.json'),
    require('cldr-data/main/es-CL/timeZoneNames.json')
);
import '/node_modules/@syncfusion/ej2-base/styles/material.css';
import '/node_modules/@syncfusion/ej2-buttons/styles/material.css';
import '/node_modules/@syncfusion/ej2-calendars/styles/material.css';
import '/node_modules/@syncfusion/ej2-dropdowns/styles/material.css';
import '/node_modules/@syncfusion/ej2-inputs/styles/material.css';
import '/node_modules/@syncfusion/ej2-navigations/styles/material.css';
import '/node_modules/@syncfusion/ej2-popups/styles/material.css';
import '/node_modules/@syncfusion/ej2-vue-schedule/styles/material.css';
import Vue from 'vue';
import {Internationalization, isNullOrUndefined, closest} from "@syncfusion/ej2-base";
import {DataManager, UrlAdaptor} from '@syncfusion/ej2-data';
import {ButtonPlugin} from "@syncfusion/ej2-vue-buttons";
import {TextBoxPlugin} from "@syncfusion/ej2-vue-inputs";
import {DropDownListPlugin} from "@syncfusion/ej2-vue-dropdowns";
import {createSpinner, showSpinner, hideSpinner} from '@syncfusion/ej2-popups';
import VueJwtDecode from "vue-jwt-decode";

import {
    SchedulePlugin,
    Week,
    Month,
    Agenda,
    DragAndDrop,
} from '@syncfusion/ej2-vue-schedule';
import * as numberingSystems from 'cldr-data/supplemental/numberingSystems.json';
import * as gregorian from '/node_modules/cldr-data/main/es-CL/ca-gregorian.json';
import * as numbers from '/node_modules/cldr-data/main/es-CL/numbers.json';
import * as timeZoneNames from '/node_modules/cldr-data/main/es-CL/timeZoneNames.json';

Vue.use(SchedulePlugin);

loadCldr(numberingSystems, gregorian, numbers, timeZoneNames);
setCulture('es-CL');
Vue.use(TextBoxPlugin);
Vue.use(DropDownListPlugin);
Vue.use(ButtonPlugin);

L10n.load({
    'es-CL': {
        'schedule': {
            "day": "Día",
            "week": "Semana",
            "workWeek": "Semana laboral",
            "month": "Mes",
            "agenda": "Agenda",
            "weekAgenda": "Agenda semanal",
            "workWeekAgenda": "Agenda semana laboral",
            "monthAgenda": "Agenda mensual",
            "today": "Hoy",
            'saveButton': 'Agregar',
            'cancelButton': 'Cerrar',
            'deleteButton': 'Borrar',
            'newEvent': 'Agendar',
        },
    }
});

let dataManager = [];
let patientId = null;
let therapistId = null;
let dragStopDate = null;
let maxDateTimer = null;
let changeStatusTimer = null;

var headerTemplateVue = Vue.component("headerTemplate", {
    template: `
        <v-card color="#f6a713" dark v-if="data.elementType === 'cell'">
        <v-card-title>
            {{ getHeaderTitle(data) }}
        </v-card-title>
        <v-card-subtitle>
            {{ getHeaderDetails(data) }}
        </v-card-subtitle>
        </v-card>
        <v-card color="#26c6da" dark v-else>
        <v-card-title>
            {{ getHeaderTitle(data) }}
        </v-card-title>
        <v-card-subtitle>
            {{ getHeaderDetails(data) }}
        </v-card-subtitle>
        </v-card>`,
    data: function () {
        return {
            intl: new Internationalization('es-CL'),
            data: {}
        };
    },
    methods: {
        getHeaderTitle: function (data) {
            if (data.elementType === "cell") {
                return "Nueva cita";
            } else if (data.elementType === "event" && data.Status === 1 || data.Status === 2) {
                return "Cita agendada";
            } else if (data.elementType === "event" && data.Status === 3) {
                return "Cita confirmada";
            }
        },
        getHeaderDetails: function (data) {
            return (
                this.intl.formatDate(data.StartTime, {type: "date", skeleton: "full"}) + " (" +
                this.intl.formatDate(data.StartTime, {skeleton: 'Hm'}) + " - " +
                this.intl.formatDate(data.EndTime, {skeleton: 'Hm'}) + ")"
            );
        }
    }
});

var contentTemplateVue = Vue.component("contentTemplate", {
    template: `
        <v-card elevation="0">
        <div class="e-cell-content" v-if="data.elementType === 'cell'">
            <v-card-text v-show="false" class="content-area">
                <ejs-textbox ref="notesObj" id="notes" placeholder="Notas">{{ data.elementType }}</ejs-textbox>
            </v-card-text>
        </div>
        <template v-if="data.elementType === 'event'">
            <v-card-text>
                <label>Paciente</label>: <span>{{ data.PatientName }}</span>
            </v-card-text>
            <v-card-text v-if="data.Description" class="notes-wrap"><label>Notas</label>:
                <span>{{ data.Description }}</span>
            </v-card-text>
        </template>
        </v-card>`,
    data: function () {
        return {
            data: {}
        };
    }
});

var footerTemplateVue = Vue.component("footerTemplate", {
    template: `
        <v-card elevation="0">
        <v-card-actions>
            <v-btn v-if="data.elementType === 'cell'"
                   id="add"
                   color="primary"
                   v-on:click.native="buttonClickActions">
                Agendar cita
            </v-btn>
            <v-btn v-if="data.elementType === 'event' && data.Status === 2"
                   id="confirm"
                   color="primary"
                   v-on:click.native="buttonClickActions">
                Confirmar
            </v-btn>
            <v-btn v-if="data.elementType === 'event'"
                   id="delete"
                   color="error"
                   v-on:click.native="buttonClickActions">
                Cancelar cita
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn id="close" v-on:click.native="buttonClickActions" fab x-small>
                <v-icon>mdi-close</v-icon>
            </v-btn>
        </v-card-actions>
        </v-card>`,
    data: function () {
        return {
            data: {}
        };
    },
    methods: {
        buttonClickActions: function (e) {
            const scheduleObj = document.querySelector(".e-schedule").ej2_instances[0];
            const quickPopup = closest(e.target, '.e-quick-popup-wrapper');
            const getSlotData = function () {
                const notesObj = quickPopup.querySelector("#notes").ej2_instances[0];
                let cellDetails = scheduleObj.getCellDetails(scheduleObj.getSelectedElements());
                if (isNullOrUndefined(cellDetails)) {
                    cellDetails = scheduleObj.getCellDetails(scheduleObj.activeCellsData.element);
                }
                let addObj = {};
                addObj.Id = scheduleObj.getEventMaxID();
                addObj.Subject = patientId;
                addObj.StartTime = new Date(+cellDetails.startTime);
                addObj.EndTime = new Date(+cellDetails.endTime);
                addObj.IsAllDay = false
                addObj.Description = isNullOrUndefined(notesObj.value) ? '' : notesObj.value;
                addObj.PatientId = patientId;
                addObj.TherapistId = therapistId;
                return addObj;
            };
            if (e.target.closest('button').id === "add") {
                const addObj = getSlotData();
                scheduleObj.addEvent(addObj);
            } else if (e.target.closest('button').id === "delete") {
                const eventDetails = scheduleObj.activeEventData.event;
                let currentAction = "Delete";
                scheduleObj.deleteEvent(eventDetails, currentAction);
            } else if (e.target.closest('button').id === "confirm") {
                const eventDetails = scheduleObj.activeEventData.event;
                eventDetails.IsConfirming = true;
                scheduleObj.saveEvent(eventDetails, "");
            } else if (e.target.closest('button').id === "close") {
                scheduleObj.closeQuickInfoPopup();
            } else {
                const isCellPopup = quickPopup.firstElementChild.classList.contains("e-cell-popup");
                const eventDetails = isCellPopup ? getSlotData() : scheduleObj.activeEventData.event;
                let currentAction = isCellPopup ? "Add" : "Save";
                if (eventDetails.RecurrenceRule) {
                    currentAction = "EditOccurrence";
                }
                scheduleObj.openEditor(eventDetails, currentAction, true);
            }
            scheduleObj.closeQuickInfoPopup();
        }
    }
});

var editorTemplateVue = Vue.component("editorTemplate", {
    template: `
        <div class="quick-info-footer">
        <div class="cell-footer">
            <ejs-button id="add" cssClass="e-flat" content="Agendar cita" :isPrimary="true"
                        v-on:click.native="buttonClickActions"></ejs-button>
        </div>
        </div>`,
    data: function () {
        return {
            data: {}
        };
    },
    methods: {
        buttonClickActions: function (e) {
            const scheduleObj = document.querySelector(".e-schedule").ej2_instances[0];
            const getSlotData = function () {
                let cellDetails = scheduleObj.getCellDetails(scheduleObj.getSelectedElements());
                if (isNullOrUndefined(cellDetails)) {
                    cellDetails = scheduleObj.getCellDetails(scheduleObj.activeCellsData.element);
                }
                let addObj = {};
                addObj.Id = scheduleObj.getEventMaxID();
                addObj.Subject = patientId;
                addObj.StartTime = new Date(+cellDetails.startTime);
                addObj.EndTime = new Date(+cellDetails.endTime);
                addObj.IsAllDay = false
                addObj.Description = '';
                addObj.PatientId = patientId;
                addObj.TherapistId = therapistId;
                return addObj;
            };
            if (e.target.id === "add") {
                const addObj = getSlotData();
                scheduleObj.addEvent(addObj);
            } else if (e.target.id === "delete") {
                const eventDetails = scheduleObj.activeEventData.event;
                let currentAction = "Delete";
                if (eventDetails.RecurrenceRule) {
                    currentAction = "DeleteOccurrence";
                }
                scheduleObj.deleteEvent(eventDetails, currentAction);
            }
            scheduleObj.closeEditor();
        }
    }
});

class CustomAdaptor extends UrlAdaptor {
    beforeSend() {
        const token = localStorage.getItem('token');
        let expiresIn = -1;
        if (token) {
            const decodedToken = VueJwtDecode.decode(token);
            const tokenExpiration = decodedToken.exp;
            expiresIn = (+tokenExpiration - (Math.round(new Date().getTime() / 1000))) * 1000;
        }
        if (expiresIn < 0) {
            window.location.reload(true);
        }
    }
}

export default Vue.extend({
    data() {
        return {
            selectedDate: new Date(),
            minDate: new Date(),
            maxDate: new Date(),
            locale: 'es-CL',
            timeScale: {enable: true, interval: 60, slotCount: 1},
            firstDayOfWeek: 1,
            eventSettings: {
                dataSource: dataManager,
                fields: {
                    id: 'Id',
                    subject: {name: 'Subject'},
                    startTime: {name: 'StartTime'},
                    endTime: {name: 'EndTime'},
                    therapist: {name: 'TherapistId'},
                    patient: {name: 'PatientId'},
                    patientName: {name: 'PatientName'},
                    Description: {name: 'Description'},
                    IsBlock: {name: 'IsBlock'},
                    IsReadonly: {name: 'IsReadonly'},
                    Status: {name: 'Status'}
                }
            },
            timeFormat: 'HH:mm',
            dateFormat: 'dd/MM/yyy',
            timezone: 'America/Santiago',
            quickInfoTemplates: {
                header: function () {
                    return {template: headerTemplateVue};
                },
                content: function () {
                    return {template: contentTemplateVue};
                },
                footer: function () {
                    return {template: footerTemplateVue};
                }
            },
            editorTemplate: function () {
                return {template: editorTemplateVue};
            },
            workHours: {
                highlight: true,
                start: '08:00',
                end: '09:00'
            },
            startHour: '09:00',
            endHour: '23:00',
            snackbar: false,
            text: '',
            timeout: 5000,
            therapistId: null,
            url: '',
        }
    },
    provide: {
        schedule: [Week, Month, Agenda, DragAndDrop]
    },
    methods: {
        onEventRendered: function (args) {
            args.element.style.backgroundColor = '#194EC7'; // this.getBackgroundColor(args.data.Status);
        },
        onNavigating: () => {
            //console.info('navigating');
        },
        async onActionFailure(args) {
            //console.info('onActionFailure');
            this.text = JSON.parse(args.error[0].error.response).message;
            this.snackbar = true;
            const scheduleObj = document.querySelector(".e-schedule").ej2_instances[0];
            scheduleObj.refresh();
            //console.log(args.error[0].error.response);
            hideSpinner(document.getElementById('app'));
        },
        onDragStop: (args) => {
            //console.info("dragStop");
            dragStopDate = args.event.target.dataset.date;
            if (!args.event.target.classList.contains('e-work-hours')) {
                args.cancel = true;
            }
        },
        async onActionBegin(args) {
            showSpinner(document.getElementById('app'));
            //console.info('onActionBegin');

            const scheduleObj = document.querySelector(".e-schedule").ej2_instances[0];
            if (args.requestType === "eventCreate") {
                if (!scheduleObj.isSlotAvailable(args.addedRecords[0].StartTime, args.addedRecords[0].EndTime)) {
                    alert("No se puede crear sesiones en paralelo.")
                    args.cancel = true;
                    hideSpinner(document.getElementById('app'));
                }
            }
            if (args.requestType === "eventChange") {
                //console.log(args);
                if (!scheduleObj.isSlotAvailable(args.data.StartTime, args.data.EndTime)) {
                    alert("No se puede crear sesiones en paralelo.");
                    args.cancel = true;
                    hideSpinner(document.getElementById('app'));
                }
                if (dragStopDate !== null) {
                    const slotStartTime = args.data.StartTime.getTime();
                    const dragStopCellStartTime = +dragStopDate;
                    if (slotStartTime !== dragStopCellStartTime) {
                        args.cancel = true;
                        hideSpinner(document.getElementById('app'));
                    }
                }
            }
            dragStopDate = null;
        },
        onActionComplete: function () {
            //console.info('onActionComplete');
            hideSpinner(document.getElementById('app'));
        },
        onCreate: function () {
            //console.info('onCreate');
        },
        onPopupOpen: function (args) {
            //console.info('onPopupOpen');
            if (args.data.IsAllDay) {
                args.cancel = true;
            }
            if (args.data.IsReadonly) {
                args.cancel = true;
            }
            if ((args.type === 'QuickInfo' || args.type === 'ViewEventInfo' || args.type === 'Editor') && !args.element.classList.contains('e-template')) {
                args.element.classList.add('e-template');
            }
            if (args.type === 'ViewEventInfo') {
                var popup = args.element.querySelector('.e-popup-footer');
                popup.style.display = 'block';
            }

            if (args.type === 'Editor') {
                //console.log('editor');
            }
        },
        async onDataBound() {
            //console.info('dataBound');
            const scheduleObj = document.querySelector(".e-schedule").ej2_instances[0];
            scheduleObj.resetWorkHours();
            var renderedDates = scheduleObj.activeView.getRenderDates();
            for (var i = 0; i < renderedDates.length; i++) {
                var dayIndex = renderedDates[i].getDay();
                if (dayIndex !== 0 && dayIndex !== 6) {
                    scheduleObj.setWorkHours([renderedDates[i]], '09:00', '13:00');
                    scheduleObj.setWorkHours([renderedDates[i]], '14:00', '22:00');
                }
            }
            const token = this.$store.getters.token;
            const response = await fetch(this.$store.getters.apiUrl + "/api/v1/"+ this.$store.getters.therapistId +"/working-slot", {
                method: 'POST',
                headers: new Headers({'Authorization': "Bearer " + token}),
                body: JSON.stringify({
                    StartDate: scheduleObj.activeView.getRenderDates()[0],
                    EndDate: scheduleObj.activeView.getRenderDates()[scheduleObj.activeView.getRenderDates().length - 1]
                })
            });
            const responseData = await response.json();
            if (response.ok) {
                //console.log(responseData);
                responseData.forEach((slot) => {
                    if (slot.isWorking) {
                        scheduleObj.setWorkHours([new Date(slot.date + ' 00:00:00')], slot.startTime, slot.endTime);
                    } else {
                        scheduleObj.resetWorkHours([new Date(slot.date + ' 00:00:00')], slot.startTime, slot.endTime);
                    }
                });
            }

            if (this.$store.getters.therapistId !== null) {
                const responseChanges = await fetch(this.$store.getters.apiUrl + "/api/v1/appointment/" + this.$store.getters.therapistId + "/get-changes", {
                    method: 'POST',
                    headers: new Headers({'Authorization': "Bearer " + token}),
                    body: JSON.stringify({
                        StartDate: scheduleObj.activeView.getRenderDates()[0],
                        EndDate: scheduleObj.activeView.getRenderDates()[scheduleObj.activeView.getRenderDates().length - 1]
                    })
                });

                const responseDataChanges = await responseChanges.json();
                if (response.ok) {
                    this.$store.commit('setStatuses', {
                        statuses: responseDataChanges.statuses
                    });
                }
            }

            hideSpinner(document.getElementById('app'));
        },
        getBackgroundColor: (index) => {
            const colorsTable = [];
            colorsTable[1] = '#FF8600';
            colorsTable[2] = '#19C73B';
            colorsTable[3] = '#194EC7';
            colorsTable[4] = '#C719A5';

            return colorsTable[index];
        },
        async maxDateWorker() {
            let token = this.$store.getters.token;
            therapistId = this.$store.getters.therapistId;
            const response = await fetch(this.$store.getters.apiUrl + "/api/v1/calendar-config/therapist/" + therapistId, {
                method: 'POST',
                headers: new Headers({'Authorization': "Bearer " + token})
            });

            const responseData = await response.json();
            if (response.ok) {
                if (this.maxDate.getTime() !== new Date(responseData.maxDate).getTime()) {
                    const today = new Date();
                    this.minDate = responseData.minDate ? new Date(responseData.minDate) : new Date().setDate(today.getDate() - 1);
                    this.maxDate = new Date(responseData.maxDate);
                }
                clearTimeout(maxDateTimer);
                maxDateTimer = setTimeout(this.maxDateWorker, 10000);
            }
        },
        async changeStatusWorker() {
            let token = this.$store.getters.token;
            therapistId = this.$store.getters.therapistId;
            if (document.querySelector(".e-schedule") !== null && therapistId !== null) {
                const scheduleObj = document.querySelector(".e-schedule").ej2_instances[0];
                const response = await fetch(this.$store.getters.apiUrl + "/api/v1/appointment/" + therapistId + "/get-changes", {
                    method: 'POST',
                    headers: new Headers({'Authorization': "Bearer " + token}),
                    body: JSON.stringify({
                        StartDate: scheduleObj.activeView.getRenderDates()[0],
                        EndDate: scheduleObj.activeView.getRenderDates()[scheduleObj.activeView.getRenderDates().length - 1]
                    })
                });

                const responseData = await response.json();
                if (response.ok) {
                    if (this.$store.getters.statuses !== responseData.statuses) {
                        this.changedTherapist();
                         scheduleObj.refresh();
                        this.$store.commit('setStatuses', {
                            statuses: responseData.statuses
                        });
                    }
                    clearTimeout(changeStatusTimer);
                    changeStatusTimer = setTimeout(this.changeStatusWorker, 10000);
                }
            } else {
                clearTimeout(changeStatusTimer);
                changeStatusTimer = setTimeout(this.changeStatusWorker, 10000);
            }
        },
        changedTherapist() {
            clearTimeout(maxDateTimer);
            clearTimeout(changeStatusTimer);
            createSpinner({
                target: document.getElementById('app')
            });
            patientId = this.$store.getters.userId;
            therapistId = this.$store.getters.therapistId;

            this.maxDateWorker();
            this.changeStatusWorker();
            this.url = this.$store.getters.apiUrl + "/api/v1/appointment/patient/" + this.$store.getters.therapistId + "/actions";
        }
    },
    created: async function () {
        this.url = this.$store.getters.apiUrl + "/api/v1/appointment/patient/" + this.$store.getters.therapistId + "/actions";
    },
    mounted() {
        this.$root.$on('changedTherapist', () => { this.changedTherapist() });
    },
    watch: {
        url: {
            handler() {
                if (this.url === '') {
                    this.url = this.$store.getters.apiUrl + "/api/v1/appointment/patient/" + this.$store.getters.therapistId + "/actions";
                }
                let token = this.$store.getters.token;
                dataManager = new DataManager({
                    url: this.url,
                    adaptor: new CustomAdaptor(),
                    crossDomain: true,
                    headers: [{'Authorization': "Bearer " + token}]
                });
                this.eventSettings.dataSource = dataManager;
                if (document.querySelector(".e-schedule") !== null) {
                    const scheduleObj = document.querySelector(".e-schedule").ej2_instances[0];
                    scheduleObj.eventSettings = this.eventSettings
                } else {
                    this.changedTherapist();
                }
            },
            immediate: true
        }
    }
});
</script>

<style scoped>
>>> .e-week-view .e-appointment {
    width: 100% !important;
}

>>> .e-quick-popup-wrapper .e-event-popup .e-popup-footer {
    display: block;
}

>>> .e-schedule .e-vertical-view .e-work-cells {
    pointer-events: none;
    background-color: #f9f9f9;
}

>>> .e-schedule .e-vertical-view .e-work-cells.e-work-hours {
    background-color: white;
    pointer-events: all !important;
}
</style>

<style>
.e-schedule-dialog.e-device .e-save-icon {
    z-index: -1 !important;
}
</style>
